import React from 'react';
import ContainerHeader from 'components/ContainerHeader/index';
import {PostData} from '/home/sygitech/Downloads/v-1.5/jumbo-react/source/src/Service/PostData';

import {
    Bar,
    BarChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
    CartesianGrid

} from 'recharts';
/*export const data = [
    {name: 'Jan', cust: 10},
    {name: 'Feb', cust: 5},
    {name: 'Mar', cust: 30},
    {name: 'Apr', cust: 20},
    {name: 'May', cust: 50},
    {name: 'Jun', cust: 1},
]*/
class DriversGraph extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data:[],
            count:'',

        };
    }
    componentDidMount() {
        this.showDriverChart();
    }
    showDriverChart() {
        PostData('totalCust', {type:"D"}).then((result) => {
            this.setState({data:result.Data,
                            count:result.Count,
                        });
        });
    } 
    render() {
        return(
            <div className="animated slideInUpTiny animation-duration-3">
                <ContainerHeader match={this.props.match} title="Drivers Graph"/>
                <div>
                    <h3>Total Count : {this.state.count} </h3>
                </div>
                <ResponsiveContainer width="100%" height={250}>
                    <BarChart data={this.state.data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="MONTH" />
                        <YAxis />
                        <Tooltip />
                       // <Bar dataKey="pv" fill="#8884d8"/>
                        <Bar dataKey="CNT" fill="#82ca9d"/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    }
}

export default DriversGraph;


// WEBPACK FOOTER //
// ./app/routes/dashboard/routes/DriversGraph/index.js